import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBomb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBomb"><Path d="M17.5 1V4H16V1H17.5Z" fill="currentColor"/><Path d="M18.5607 6.5L16.1624 8.89824C17.3101 10.283 18 12.0609 18 14C18 18.4183 14.4183 22 10 22C5.58172 22 2 18.4183 2 14C2 9.58172 5.58172 6 10 6C11.9391 6 13.717 6.68988 15.1018 7.83758L17.5 5.43934L18.5607 6.5Z" fill="currentColor"/><Path d="M20 6.5V8H23V6.5H20Z" fill="currentColor"/><Path d="M22.3107 2.75L20 5.06066L18.9393 4L21.25 1.68934L22.3107 2.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBomb;
